import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { LITERALS } from 'src/app/core/constants/literals.constant';
import { ProfileService } from 'src/app/core/services/profile.service';
import { ErrorMessageComponent } from '../../all-modals/error-message/error-message.component';
import { SuccessMessageComponent } from '../../all-modals/success-message/success-message.component';
import { PublicationPreviewWrapperComponent } from '../../material-detail/publication-preview-wrapper/publication-preview-wrapper.component';
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'app-report-connection-modal',
  templateUrl: './report-connection-modal.component.html',
  styleUrls: ['./report-connection-modal.component.scss']
})
export class ReportConnectionModalComponent implements OnInit {

  @Input() public connection;
  @Input() public content;
  @Input() public type;

  reportForm: FormGroup; userData;
  submitted = false;
  notValid = false;
  isImagePreview = false;
  imagePath;
  isImageError = false;
  fileSizeError = false;
  showPreview = false;
  imgURL;
  selectedFile: File;
  reasons = [
    'Abusive or Hateful',
    'Fake Account',
    'Harassment',
    'Piracy',
    'Promotes harmful or dangerous Act',
    'Promotes inappropriate content',
    'Other'
  ];
  reasonsContent = [
    'Material Piracy',
    'Spam',
    'Promotes Terrorism',
    'Violent content',
    'Hateful content',
    'Harmful content',
    'Child abuse'
  ];
  reasonsArray = [];
  constructor(
    private activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private _profileService: ProfileService,
    private spinner: NgxSpinnerService,
    private authService: AuthService,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    this.userData = this.authService.getCurrentUser();
    this.reportForm = this.formBuilder.group({
      comment: ['', Validators.required]
    });
    if (this.type == 'content') {
      this.reasons = this.reasonsContent;
    }
  }
  closeDialog() {
    this.activeModal.dismiss();
  }
  reportConnection() {
    this.submitted = true;
    if (this.reportForm.invalid) {
      if (this.reasonsArray.length === 0) {
        this.notValid = true;
      }
      return;
    }
    if (this.reasonsArray.length === 0) {
      // this.toastr.warning(LITERALS.AUTH.ERROR_MESSAGES.SELECT_REPORT_REASON);
      this.notValid = true;
      return;
    }
    this.spinner.show();
    const params = {
      ...this.reportForm.value,
      "reason": this.reasonsArray
    }
    if (this.selectedFile) {
      params['file'] = this.selectedFile;
    }
    if (!this.type) {
      params.report_to_id = this.connection.otherId;
      params.report_by_id = this.userData.user.id;
      this._profileService.reportConnection(this.connection.id, params).subscribe(
        (response: any) => {
          this.activeModal.dismiss();
          this.spinner.hide();
          if (response.success) {
            const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
            modelRef.componentInstance.message = LITERALS.AUTH.SUCCESS_MESSAGES.USER_REPORT_SUCCESS;
          } else if (response.status == 422) {
            const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
            modalRef.componentInstance.message = "You have already reported this user.";
          } else {
            const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
            if (response.errors == "You can't report your child account!") {
              modelRef.componentInstance.message = "Oops!, you cannot report your supplementary account.";
            }
            else if (response.errors == "You are not able to report your parent account!") {
              modelRef.componentInstance.message = "Oops!, you cannot report your parent account.";
            }

            modelRef.componentInstance.title = "Alert!";
          }

        }, (error: any) => {
          this.activeModal.dismiss();
          this.spinner.hide();
        });
    }else{
      const params = {
        'report_comment': this.reportForm.get('comment').value,
        "report_reason": this.reasonsArray,
        'user_id': this.content.user_id
      }
      params['content_id'] = this.content.id;
      this._profileService.reportContent(params).subscribe(
        (response: any) => {
          this.activeModal.dismiss();
          this.spinner.hide();
          if (response.success) {
            const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
            modelRef.componentInstance.message = LITERALS.AUTH.SUCCESS_MESSAGES.USER_REPORT_SUCCESS;
          } else if (response.status == 422) {
            const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
            modalRef.componentInstance.message = "You have already reported this content.";
            // this.toastr.warning(response.errors[0].detail);
          } else {
            const modelRef = this.modalService.open(SuccessMessageComponent, { centered: true });
            if (response.errors == "You can't report your child account!") {
              modelRef.componentInstance.message = "Oops!, you cannot report your supplementary account.";
            }
            else if (response.errors == "You are not able to report your parent account!") {
              modelRef.componentInstance.message = "Oops!, you cannot report your parent account.";
            }

            modelRef.componentInstance.title = "Alert!";
            // this.toastr.warning(LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
          }

        }, (error: any) => {
          this.activeModal.dismiss();
          this.spinner.hide();
          // this.toastr.warning(LITERALS.AUTH.ERROR_MESSAGES.SOMETHING_WENT_WRONG);
        });
    }
  }
  updateReportArray(event) {
    if (event.target.checked) {
      this.reasonsArray.push(event.target.value);
    } else {
      this.reasonsArray = this.reasonsArray.filter(element => {
        return element != event.target.value;
      });
    }
    this.notValid = false;
  }

  preview(files) {
    if (files.length === 0)
      return;

    this.isImagePreview = false;
    let mineType = files[0].type;

    var reader = new FileReader();
    this.imagePath = files;
    reader.readAsDataURL(files[0]);

    this.isImageError = false;
    this.fileSizeError = false;

    var fileName = files[0].name.split('.');
    const extension = fileName[fileName.length - 1];

    if ((!mineType.match(/image\/*/)) && (!mineType.match(/pdf\/*/)) && (!mineType.match(/document\/*/) || (extension == 'svg' || extension == 'SVG'))) {
      this.isImageError = true;
      return;
    }
    if (files[0].size / 1048576 > 4.999) {
      this.fileSizeError = true;
      return;
    }

    reader.onload = (_event) => {
      if (mineType.match(/image\/*/)) {
        this.isImagePreview = true;
      }
      this.showPreview = true;
      this.imgURL = reader.result;
      this.selectedFile = files[0];
    }

    this.isImageError = false;
    this.fileSizeError = false;
  }

  removeFile() {
    this.imgURL = "";
    this.showPreview = false;
    this.isImagePreview = false;
  }

  filePreview() {
    const modelRef = this.modalService.open(PublicationPreviewWrapperComponent, { centered: true, size: "lg", windowClass: 'pdf-modal' });
    modelRef.componentInstance.url = this.imgURL;
  }

}
